export const MAX_COMPARE = 3;
export const MIN_COMPARE = 2;

export function parseCompareParam(raw: string | null | undefined): string[] {
  if (!raw) return [];
  return [...new Set(raw.split(',').filter(Boolean))].slice(0, MAX_COMPARE);
}

export function nextSelection(current: string[], id: string): string[] {
  if (current.includes(id)) return current.filter((x) => x !== id);
  if (current.length >= MAX_COMPARE) return current;
  return [...current, id];
}

export function toCompareParam(ids: string[]): string | null {
  return ids.length ? ids.join(',') : null;
}
